import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { Form, DatePicker, Button } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useIntl } from "react-intl";

type IProps = {
  field: string;
  value?: string[];
  onFinish: (values: any) => void;
};

const DropdownSearchFilter: React.FC<IProps> = ({ field, value, onFinish }) => {
  const { messages } = useIntl();
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldValue(
      "value",
      value?.map((v) => dayjs(v)),
    );
  }, [value]);

  return (
    <Form
      form={form}
      name={`date_range_search_filter_form_${field}`}
      autoComplete="off"
      style={{ padding: "16px" }}
      className="table-action-form"
      onFinish={({ value }) => {
        onFinish({
          field,
          value: value.map((v) => v.format("YYYY-MM-DD")),
        });
      }}
    >
      <Form.Item style={{ marginBottom: 10 }} name="value">
        <DatePicker.RangePicker format="YYYY-MM-DD" />
      </Form.Item>

      <Form.Item style={{ marginBottom: 0 }}>
        <StyledFlex style={{ justifyContent: "space-between" }}>
          <Button
            data-testid="reset"
            htmlType="reset"
            type="link"
            onClick={() => onFinish({ field, value: undefined })}
          >
            {messages["common.reset"] as string}
          </Button>
          <Button
            data-testid="submit"
            htmlType="submit"
            type="primary"
            loading={false}
          >
            {messages["common.submit"] as string}
          </Button>
        </StyledFlex>
      </Form.Item>
    </Form>
  );
};

export default DropdownSearchFilter;
